import { createSlice } from '@reduxjs/toolkit';
import SuperMarketService from '../services/SuperMarketService';
import errorHandle from './errorHandle';

// 其他應用市集功能
export const superMarketSlice = createSlice({
  name: 'EC',
  initialState: {
    EC: {
      isEnabledSetting: false,
      provider: null,
      membershipTier: [],
    },
    couponList: [],
  },
  reducers: {
    setCouponList: (state, action) => ({
      ...state,
      couponList: action.payload,
    }),
    setEC: (state, action) => ({
      ...state,
      EC: {
        ...state.EC,
        ...action.payload,
      },
    }),
  },
});

export const { setEC, setCouponList } = superMarketSlice.actions;

export const getECStatus = orgId => async dispatch => {
  try {
    const provider = await SuperMarketService.getOrgEnabledEC(orgId);

    dispatch(setEC({ provider }));

    if (provider) {
      const isEnabledSetting = await SuperMarketService.getECIsEnabledSetting(
        provider,
        orgId,
      );

      dispatch(setEC({ isEnabledSetting }));
    }
  } catch (error) {
    dispatch(errorHandle(error));
  }
};

export const getECMembershipTier = (provider, orgId) => async dispatch => {
  try {
    const membershipTier = await SuperMarketService.getECMembershipTier(
      provider,
      orgId,
    );

    dispatch(setEC({ membershipTier }));
  } catch (error) {
    dispatch(errorHandle(error));
  }
};

export const getCouponList = orgId => async dispatch => {
  try {
    dispatch(setCouponList([]));

    const result = await SuperMarketService.getCouponList(orgId);

    dispatch(setCouponList(result));
  } catch (error) {
    dispatch(setCouponList([]));
    dispatch(errorHandle(error));
  }
};

export default superMarketSlice.reducer;
